export interface GlobalNotificationMessage {
  text: string;
  title?: string;
}

export class GlobalNotification {
  mRoom = new URL(CrowdHub_App.CONFIG.BASE_URL).hostname + '-global';
  mConstructorParams?: any;

  constructor(aConstructorParams?: any) {
    this.mConstructorParams = aConstructorParams;

    this.loadHistory();
    this.attachEvents();
  }

  loadHistory(): void {
    PubNubCenter.INSTANCE?.fetchRoomHistory(this.mRoom, (status, response) => {
      if (status.statusCode === 404) {
        // no history.
        return;
      } else if (status.error) {
        console.warn(status?.errorData?.message);
        return;
      } else {
        // Do nothing with global notification history for now.
      }
    });
  }

  attachEvents(): void {
    //listen for messages
    PubNubCenter.INSTANCE?.subscribeToRoom(this.mRoom, false);
    PubNubCenter.INSTANCE?.addEventListener(
      PubNubCenter.ON_MESSAGE,
      (event, data) => {
        if (data?.channel == this.mRoom) {
          this.onMessageReceived(event, data);
        }
      },
      this,
    );
  }

  onMessageReceived(event: any, data: any): void {
    if (data?.message?.text) {
      const notification = data.message as GlobalNotificationMessage;
      const confirmPopup = new ConfirmPopupPanel();
      confirmPopup.showOkConfirm(
        notification.title || CrowdHub_App.LANG.GLOBAL_NOTIFICATION_POPUP_TITLE,
        notification.text,
        null,
      );
    } else {
      console.warn('Invalid global notification', event, data);
    }
  }

  onSendMessage(aMessage: GlobalNotificationMessage): void {
    PubNubCenter.INSTANCE?.messageChannel(this.mRoom, aMessage, (status, response) => {});
  }

  destroy() {
    PubNubCenter.INSTANCE?.unsubscribeToRoom(this.mRoom);
    PubNubCenter.INSTANCE?.removeEventListenerByScope(PubNubCenter.ON_MESSAGE, this);
  }
}
